"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _currency = require("@nerdwallet/currency");

var _impression = require("@nerdwallet/analytics/react/impression");

var _ourTakeHighlightModule = _interopRequireDefault(require("./our-take-highlight.module.css"));

var _constants = require("./constants");

var OurTakeHighlight = function OurTakeHighlight(_ref) {
  var bannerType = _ref.bannerType,
      content = _ref.content,
      analytics = _ref.analytics;

  if (!bannerType || !content || !_constants.BANNER_TEXT[bannerType]) {
    return null;
  }

  var component = /*#__PURE__*/_react.default.createElement("div", {
    className: _ourTakeHighlightModule.default.ourTakeWrapper
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _ourTakeHighlightModule.default.banner
  }, /*#__PURE__*/_react.default.createElement(_currency.Accent, {
    size: "small"
  }, _constants.BANNER_TEXT[bannerType])), /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small"
  }, content));

  return analytics ? /*#__PURE__*/_react.default.createElement(_impression.Impression, {
    enabled: true,
    eventType: "element_impression",
    entityName: analytics === null || analytics === void 0 ? void 0 : analytics.entityName,
    payload: {
      section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
    }
  }, component) : component;
};

var _default = OurTakeHighlight;
exports.default = _default;